/* Two independent native-scroll rows, one accessible playback control. */
(() => {
  if (customElements.get('dm-pet-portfolio')) return;
  class PetPortfolio extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const mobile=matchMedia('(max-width: 768px)');
      if(mobile.matches){
        const viewport=this.querySelector('[data-portfolio-viewport]');
        const controls=this.querySelector('[data-portfolio-controls]');
        const toggle=this.querySelector('[data-portfolio-toggle]');
        if(!viewport || !controls || !toggle) return;
        const abort=new AbortController();
        toggle.hidden=true;
        this.querySelectorAll('[data-portfolio-step]').forEach(button=>button.addEventListener('click',()=>{
          const card=viewport.querySelector('.dm-portfolio__card');
          if(card) viewport.scrollBy({left:Number(button.dataset.portfolioStep)*(card.getBoundingClientRect().width+14),behavior:'smooth'});
        },{signal:abort.signal}));
        const reset=()=>{this.cleanup?.();this.connectedCallback();};
        mobile.addEventListener('change',reset,{signal:abort.signal});
        controls.hidden=false;
        this.cleanup=()=>{abort.abort();toggle.hidden=false;controls.hidden=true;this.cleanup=null;};
        return;
      }
      const toggle=this.querySelector('[data-portfolio-toggle]');
      const viewports=[...this.querySelectorAll('[data-portfolio-viewport]')];
      if(!toggle || !viewports.length) return;
      const abort=new AbortController();
      const on=(node,event,fn,options={})=>node.addEventListener(event,fn,{...options,signal:abort.signal});
      const media=matchMedia('(prefers-reduced-motion: reduce)');
      on(mobile,'change',()=>{this.cleanup?.();this.connectedCallback();});
      let paused=media.matches || this.dataset.autoplay!=='true',frame=0,last=0;
      const speed=Math.min(60,Math.max(10,Number(this.dataset.speed)||24));
      const rows=viewports.map(viewport=>{
        const track=viewport.querySelector('[data-portfolio-track]');
        const cards=[...track.children];
        const clones=cards.map(card=>{const clone=card.cloneNode(true);clone.setAttribute('aria-hidden','true');clone.inert=true;clone.dataset.portfolioClone='';track.append(clone);return clone;});
        return {viewport,track,cards,clones,direction:Number(viewport.dataset.direction)||1,span:0,position:viewport.scrollLeft,hover:false,focused:false,visible:false,initialized:false};
      });
      const update=()=>{toggle.textContent=paused ? this.dataset.playLabel : this.dataset.pauseLabel;toggle.setAttribute('aria-pressed',String(paused));};
      const active=row=>!paused&&!row.hover&&!row.focused&&row.visible&&!document.hidden&&row.span>0;
      const tick=time=>{
        frame=0;if(!rows.some(active)){last=0;return;}
        if(last)rows.filter(active).forEach(row=>{
          row.position+=Math.min(time-last,50)/1000*speed*row.direction;
          row.position=((row.position%row.span)+row.span)%row.span;
          row.viewport.scrollLeft=row.position;
        });
        last=time;frame=requestAnimationFrame(tick);
      };
      const sync=()=>{
        rows.forEach(row=>{row.position=row.viewport.scrollLeft;});
        if(!rows.some(active)){cancelAnimationFrame(frame);frame=0;last=0;}
        else if(!frame){last=0;frame=requestAnimationFrame(tick);}
      };
      const measure=()=>{rows.forEach(row=>{
        row.span=row.clones[0].offsetLeft-row.cards[0].offsetLeft;
        if(!row.initialized&&row.span>0){if(row.direction<0&&!paused)row.viewport.scrollLeft=row.span;row.initialized=true;}
        row.position=row.viewport.scrollLeft;
      });sync();};
      const pause=()=>{paused=true;update();sync();};
      on(toggle,'click',()=>{paused=!paused;update();sync();});
      rows.forEach(row=>{
        const v=row.viewport;
        on(v,'pointerenter',e=>{if(e.pointerType==='mouse'){row.hover=true;sync();}});
        on(v,'pointerleave',()=>{row.hover=false;sync();});
        on(v,'pointerdown',pause,{passive:true});
        on(v,'wheel',e=>{if(Math.abs(e.deltaX)>Math.abs(e.deltaY))pause();},{passive:true});
        on(v,'keydown',e=>{if(['ArrowLeft','ArrowRight','Home','End','PageUp','PageDown'].includes(e.key))pause();});
        on(v,'focusin',()=>{row.focused=true;sync();});
        on(v,'focusout',()=>{row.focused=false;sync();});
      });
      on(document,'visibilitychange',sync);
      on(media,'change',()=>{if(media.matches)pause();});
      this.querySelectorAll('[data-portfolio-step]').forEach(button=>on(button,'click',()=>{
        pause();rows.forEach(row=>{
          if(!row.span)return;
          const distance=row.cards[0].getBoundingClientRect().width+parseFloat(getComputedStyle(row.track).gap);
          const next=row.viewport.scrollLeft+Number(button.dataset.portfolioStep)*distance;
          row.viewport.scrollLeft=((next%row.span)+row.span)%row.span;row.position=row.viewport.scrollLeft;
        });
      }));
      const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{const row=rows.find(r=>r.viewport===entry.target);if(row)row.visible=entry.isIntersecting;});sync();},{threshold:.1});
      const resize=new ResizeObserver(measure);
      rows.forEach(row=>{observer.observe(row.viewport);resize.observe(row.viewport);});
      this.querySelector('[data-portfolio-controls]').hidden=false;
      measure();update();
      this.cleanup=()=>{abort.abort();observer.disconnect();resize.disconnect();cancelAnimationFrame(frame);rows.forEach(row=>row.clones.forEach(clone=>clone.remove()));this.cleanup=null;};
    }
    disconnectedCallback(){this.cleanup?.();}
  }
  const start=()=>{if(!customElements.get('dm-pet-portfolio')) customElements.define('dm-pet-portfolio',PetPortfolio);};
  const root=document.querySelector('dm-pet-portfolio');
  if(root && 'IntersectionObserver' in window){
    const observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){observer.disconnect();start();}},{rootMargin:'1000px 0px'});
    observer.observe(root);
  }else start();
})();
